interface SectionLabelProps {
  children: string;
  tone?: "dark" | "light";
  className?: string;
}

export default function SectionLabel({ children, tone = "dark", className = "" }: SectionLabelProps) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <span className="h-[2px] w-8 bg-primary-500" />
      <span
        className={`font-label text-[11px] uppercase tracking-[0.24em] ${
          tone === "dark" ? "text-foreground-500" : "text-background-300"
        }`}
      >
        {children}
      </span>
    </div>
  );
}